import { findPort, itemName } from '../../trace/ports.js';
import { BUILTIN_CATALOG } from '../../catalog/builtin.js';
import { defineRule } from '../rule.js';

/**
 * W: a device that needs +48V (output port with `phantom: true`) feeds channels none of which has
 * phantom switched on, or is cabled straight into an input that explicitly has no phantom.
 */
export const condenserWithoutPhantom = defineRule(
  'condenser-without-phantom',
  'warning',
  { en: 'Condenser without phantom power', de: 'Kondensator ohne Phantomspeisung' },
  (data, emit) =>
    Object.values(data.items).flatMap((item) => {
      const needing = (item.ports ?? []).filter((p) => p.direction === 'out' && p.phantom === true);
      // without ports the catalog model says whether it needs +48V
      const byModel =
        (item.ports ?? []).length === 0 &&
        item.catalogRef !== undefined &&
        BUILTIN_CATALOG.entries.some((e) => e.ref === item.catalogRef && e.phantom === true);
      if (needing.length === 0 && !byModel) return [];
      const channels = Object.values(data.channels).filter((ch) => ch.sourceItemId === item.id);
      const noPhantomChannel = channels.length > 0 && channels.every((ch) => ch.phantom !== true);
      const deadInputs = Object.values(data.connections).filter(
        (c) =>
          c.from.itemId === item.id &&
          needing.some((p) => p.id === c.from.portId) &&
          findPort(data, c.to.itemId, c.to.portId)?.phantom === false,
      );
      if (!noPhantomChannel && deadInputs.length === 0) return [];
      return [
        emit([item.id, ...channels.map((ch) => ch.id), ...deadInputs.map((c) => c.id)], {
          label: itemName(item),
        }),
      ];
    }),
);
